
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { FormDataStructure } from '@/contracts/forms/FieldContracts'
import { getStage1FormDataStructure } from '@/composables/formdata'
import Heading from '@/components/Heading.vue'
import Form from '@/components/Form.vue'

export default defineComponent(
{
    name: 'Home',
    components:
    {
        Heading,
        Form
    },
    setup()
    {
        // Load router:
        const router = useRouter()
        // Load vuex:
        const store = useStore()
        // Get form data:
        const stage1Data = store.getters['formData/stage1Data']

        // Set fieldsets:
        const fieldsets =
        [
            {
                name: 'lastname',
                text: 'What was their last name?'
            },
            {
                name: 'firstname',
                text: 'What was their first name?'
            },
            {
                name: 'yearofdeath',
                text: 'What was their year of death?'
            },
            {
                name: 'wasasoldier',
                text: 'Was the person a soldier who died while serving in the British armed forces between 1850 and 1986?',
                hide: true
            }
        ]
        // Set fields:
        const fields = getStage1FormDataStructure(stage1Data)
        // Set buttons:
        const buttons =
        {
            submit:
            {
                name: 'submit',
                type: 'Submit',
                text: 'Save and continue'
            }
        }
        // Handle submission:
        const saveFormData = (formData: FormDataStructure) =>
        {
            store.commit('formData/setStage1Data', formData)
            router.push({ name: 'Search' })
        }

        // Return data:
        return {
            fieldsets,
            fields,
            buttons,
            saveFormData
        }
    }
})
